"use client";

import React, { useRef } from "react";
import Image from "next/image";
import TypographyMontserrat from "../../Atoms/TypographyMontserrat";
import { ShoppingBag } from "../../../public/Theme";
import { useIntersectionObserver, useWindowSize } from "@uidotdev/usehooks";

const ShoppableVideoCard = ({ item }) => {
    const windowSize = useWindowSize();
    const VideoRef = useRef(null);
    const [intersectionRef, entry] = useIntersectionObserver({
        threshold: 0,
        root: null,
        rootMargin: "0px",
    });

    const PlayPauseVideo = (e) => {
        if (e.type === "mouseenter") {
            VideoRef.current?.play();
        } else {
            VideoRef.current?.pause();
            if (item?.video_placeholder_image?.url) {
                VideoRef.current.currentTime = 0;
                VideoRef.current?.load();
            }
        }
    };

    return (
        <div
            className="relative px-1 sm:px-2"
            onMouseEnter={PlayPauseVideo}
            onMouseLeave={PlayPauseVideo}
            ref={intersectionRef}
        >
            <video
                ref={VideoRef}
                poster={item?.video_placeholder_image?.url}
                playsInline={true}
                webkit-playsinline={"true"}
                disablePictureInPicture={true}
                autoPlay={
                    windowSize?.width < 600 && windowSize?.width != null
                        ? true
                        : false
                }
                muted={true}
                preload="metadata"
                loop={true}
                src={item?.product_video?.url || null}
            ></video>
            <div className="absolute bottom-0 w-[calc(100%-8px)] min-[800px]:w-[calc(100%-16px)] h-[calc(100%+244px)] flex flex-col justify-end p-1 min-[800px]:p-2 min-[800px]:translate-y-56 min-[800px]:opacity-1 min-[800px]:hover:translate-y-0 min-[800px]:hover:opacity-100 min-[800px]:transition-all min-[800px]:duration-500">
                {item?.product_image?.url && (
                    <div className="flex flex-col items-end w-full">
                        <div className="relative bg-Tertiary_Backgroung animate-bounce rounded-full px-2 min-[800px]:px-3 py-1 mb-2">
                            <TypographyMontserrat
                                text={"Tap to shop"}
                                fontWeight={"medium"}
                                customStyle={
                                    " !text-[10px] min-[800px]:!text-sm "
                                }
                            />
                            <div className=" absolute w-2 h-2 rotate-45 bg-Tertiary_Backgroung right-3 min-[800px]:right-5 " />
                        </div>

                        <div className=" h-8 w-8 min-[800px]:h-12 min-[800px]:w-12 bg-Tertiary_Backgroung rounded-full p-1 mb-4 min-[800px]:mb-8">
                            <a target="_blank" href={item?.product_link?.url}>
                                <div className="relative w-full h-full">
                                    <Image
                                        src={ShoppingBag}
                                        alt={item?.product_name}
                                        fill
                                        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                    />
                                </div>
                            </a>
                        </div>
                    </div>
                )}
                {item?.product_link?.url && (
                    <a target="_blank" href={item?.product_link?.url}>
                        <div className=" w-full h-12 min-[800px]:h-16 rounded-lg bg-Primary_Background flex items-center p-[6px]">
                            {item?.product_image?.url && (
                                <div className="relative h-full aspect-square">
                                    <img
                                        src={item?.product_image?.url}
                                        alt={item?.product_name}
                                        className="h-full aspect-square"
                                    />
                                </div>
                            )}
                            {item?.product_name && (
                                <TypographyMontserrat
                                    text={item?.product_name}
                                    fontWeight={"medium"}
                                    customStyle={
                                        " !text-[10px] min-[800px]:!text-sm text-start p-2 "
                                    }
                                />
                            )}
                        </div>
                    </a>
                )}
            </div>
        </div>
    );
};

export default ShoppableVideoCard;
